import Validator from './Validator';

/* global FormValidation */

export default function validateUpdateCompanyGeneralSettings(form) {
  return Validator.create(
    form,
    {
      font: {
        validators: {
          notEmpty: {
            message: 'Schriftart ist ein Pflichtfeld',
          },
        },
      },
      mainColor: {
        validators: {
          color: {
            message: 'Hauptfarbe muss eine Farbe sein',
          },
        },
      },
      buttonTextColor: {
        validators: {
          color: {
            message: 'Button Textfarbe muss eine Farbe sein',
          },
        },
      },
      textColor: {
        validators: {
          color: {
            message: 'Textfarbe muss eine Farbe sein',
          },
        },
      },
      backgroundColor: {
        validators: {
          color: {
            message: 'Hintergrundfarbe muss eine Farbe sein',
          },
        },
      },
      applicationSuccessMessage: {
        validators: {
          notEmpty: {
            message: 'Nachricht ist ein Pflichtfeld',
          },
        },
      },
      speculativeApplicationText: {
        validators: {
          notEmpty: {
            message: 'Nachricht ist ein Pflichtfeld',
          },
        },
      },
      speculativeApplicationSuccessMessage: {
        validators: {
          notEmpty: {
            message: 'Nachricht ist ein Pflichtfeld',
          },
        },
      },
    },
    {
      excluded: new FormValidation.plugins.Excluded({
        // NOTE: exclude speculativeApplicationText and speculativeApplicationSuccessMessage validation
        // if speculativeApplicationActive checkbox has not been checked
        excluded: field =>
          (field === 'speculativeApplicationText' ||
            field === 'speculativeApplicationSuccessMessage') &&
          !form.querySelector('[name="speculativeApplicationActive"]').checked,
      }),
    },
  );
}
